import React, { useCallback, useState } from 'react';

import { DialogContent, Modal as MUIModal } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import LinkedInModal from '../components/LinkedInModal';
import ShareModal from '../components/ShareModal/ShareModal';
import VideoModal from '../components/VideoModal/VideoModal';
import LeaveModal from '../pages/TestPage/components/LeaveModal';
import Confirm from './Confirm';

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    dialog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:focus': {
        outline: 'none',
      },
    },
  }),
);

export enum Modals {
  LinkedInModal = 'LinkedInModal',
  ShareModal = 'ShareModal',
  LeaveModal = 'LeaveModal',
  VideoModal = 'VideoModal',
  Confirm = 'Confirm',
}

const modalViews = {
  LinkedInModal,
  ShareModal,
  LeaveModal,
  VideoModal,
  Confirm,
};

const Modal = ({ children, ...rest }) => {
  const [selected, setSelected] = useState('');
  const classes = useStyles();

  const CurrentModal = modalViews[selected] || null;

  const openModal = useCallback((name: Modals) => setSelected(name), []);
  const closeModal = useCallback(() => setSelected(''), []);

  return (
    <>
      {children({ openModal, closeModal })}
      <MUIModal open={!!selected} className={classes.modal}>
        <DialogContent className={classes.dialog}>
          {CurrentModal && <CurrentModal {...rest} closeModal={closeModal} openModal={openModal} />}
        </DialogContent>
      </MUIModal>
    </>
  );
};

export default Modal;
